import styled, { keyframes, css } from 'styled-components';

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const animationRule = css`
  ${spin} 1s infinite alternate;
`;

const StyledLogo = styled.img`
  width: var(--login-logo-width);
  display: block;
  align-content: center;
  margin-top: var(--primary-top-bar-logo-margin-top, 5px);
  padding: var(--primary-top-bar-logo-padding, 0);
  background: var(--primary-top-bar-logo-background, transparent);
  margin: var(--primary-top-bar-logo-margin, 0 1.6rem);
  ${(props) => !!props.loading && `animation: ${animationRule};`}
`;

export { StyledLogo };
